import { useState } from "react"

export function useLocalStorage(key: string, initialValue: string) {
  const [storedValue, setStoredValue] = useState<string | null>(() => {
    if (typeof window === "undefined") {
      return null
    }
    const item = window.localStorage.getItem(key)
    return item ? item : initialValue
  })

  const setValue = (value: string) => {
    // Only update if the value is different
    if (value !== storedValue) {
      setStoredValue(value)
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, value)
      }
    }
  }

  return [storedValue, setValue] as const
}
